import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ROUTES } from '../../constants/routes'
import { Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.css"],
})
export class AuthLayoutComponent implements OnInit {
  
  public location: Location;
  public isCollapsed = false;
  public listTitles =  [];

  public isMobile = Capacitor.getPlatform() !== 'web';

  /**
   * @constructor
   * @param {Location} _location 
   * @param {Router} _router  
   */
  constructor(
    private _location: Location,
    private _router: Router
  ) {
    this.location = _location;
  }
  
  /**
   * On Init
   * @returns {void}
   */
  ngOnInit(): void {
    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    this._router.events.subscribe((event) => {
      this.isCollapsed = false;
      const navbar = document.getElementsByTagName("nav")[0];
      if (this.isCollapsed) {
        navbar.classList.remove("navbar-transparent");
        navbar.classList.add("bg-white");
      } else {
        navbar.classList.add("navbar-transparent");
        navbar.classList.remove("bg-white");
      }
    });
  }

  /**
   * Collapse
   * @returns {void}
   */
  public collapse(): void{
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName("nav")[0];
    if (this.isCollapsed) {
      navbar.classList.remove("navbar-transparent");
      navbar.classList.add("bg-white");
    } else {
      navbar.classList.add("navbar-transparent");
      navbar.classList.remove("bg-white");
    }
  }
}
